import { render, staticRenderFns } from "./trainingStatistics.vue?vue&type=template&id=79c3d81a&scoped=true"
import script from "./trainingStatistics.vue?vue&type=script&lang=js"
export * from "./trainingStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c3d81a",
  null
  
)

export default component.exports